import React, { useState } from "react";
import { FooterTopComp, FooterBottomComp } from "./components/index";
import { Col, Container, Row, Modal } from "react-bootstrap";
import { Typography } from "@mui/material";
const Footer = ({ show, getProducts }) => {
	const [modalShow, setModalShow] = useState(false);

	return (
		<>
			<footer
				id='main_footer'
				style={{ paddingTop: "20px" }}>
				<div className='container'>
					<FooterTopComp
						getProducts={getProducts}
						show={show}
						setModalShow={setModalShow}
						modalShow={modalShow}
					/>
				</div>
				<FooterBottomComp
					setModalShow={setModalShow}
					modalShow={modalShow}
				/>
				<Modal backdrop="static"
					centered
					dialogClassName="modal-90w"
					keyboard={false}
					show={modalShow}
					onHide={() => setModalShow(false)}
					aria-labelledby="contained-modal-title-vcenter">
					<Modal.Header className="modal-bg" closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Disclaimer
						</Modal.Title>
					</Modal.Header>
					<Modal.Body
						style={{ maxHeight: "80vh", overflowY: "scroll" }} className="grid-example modal-bg">
						<Container>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
								Welcome to Shareholder Agahi, a collaborative initiative by the Pakistan Institute of Corporate Governance (PICG) and the Central Depository Company of Pakistan (CDC). The content and services provided on this platform are intended to enhance shareholder awareness and understanding of their rights and responsibilities, as well as to offer them tools to facilitate active participation during general meetings and other shareholder events.
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								Educational Content
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							The information, resources, and training modules available on Shareholder Agahi are designed for educational purposes only. While we strive to ensure the accuracy and relevance of the content, it should not be construed as legal, financial, or professional advice. Users are encouraged to seek independent advice from qualified professionals before making any decisions based on the information provided on this site.							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								Tools for Participation
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							Shareholder Agahi offers various tools, including e-Meetings, e-Voting, and e-Proxy, to facilitate shareholder participation in corporate governance. These tools are provided as-is, and while every effort is made to ensure their functionality and security, we do not guarantee their continuous operation, or the accuracy of results obtained through their use. Users are responsible for ensuring the integrity of their participation and should be aware of the potential risks involved.							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								No Warranties
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							Shareholder Agahi, its affiliates, and partners make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								Limitation of Liability
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							Under no circumstances will Shareholder Agahi, PICG, CDC, or any associated parties be liable for any loss or damage, including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								External Links
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							Shareholder Agahi may contain links to external websites that are not provided or maintained by or in any way affiliated with us. Please note that we do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="h6" gutterBottom>
								Changes to This Disclaimer
							</Typography>
							<Typography sx={{ margin: "1em 0 10px 0" }} variant="body1" gutterBottom>
							We may update this disclaimer from time to time. We encourage you to review this page periodically for any changes. Your continued use of the website following the posting of changes to this disclaimer will be deemed your acceptance of those changes.							</Typography>

						</Container>
					</Modal.Body>
				</Modal>
			</footer>
		</>
	);
};

export default Footer;
